/* Version: 3.5.155 */
'use client';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import 'react';
import { safeRest } from '../../utils/functions.js';
import { StyledImage } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';

var CardImage = function CardImage(props) {
  var safeProps = safeRest(props);
  return /*#__PURE__*/jsx(StyledImage, _objectSpread({}, safeProps));
};
process.env.NODE_ENV !== "production" ? CardImage.displayName = 'CardImage' : undefined;

export { CardImage as default };
